export default __webpack_public_path__ + "static/media/misc-bathtubA-1024w.d2e571e2.png";